
import log from "plugins/loglevel/index"
import Cookies from "plugins/cookies-js/index"

import { Page } from "app/multi_device"
import MapMode from "app/map/mode/manager"
import PageInstance from "app/page_instance/index"
import MapDefaults from "app/map/defaults"

const LIST_VIEW_CONCIERGE_TIMES = {
  RESIDENTIAL: {
    DEFAULT:  70000,
    TAIWAN:   30000,
    CHINA:    15000,
  },
  COMMERCIAL: {
    DEFAULT:  20000,
    TAIWAN:   20000,
    CHINA:    20000,
  },
}

const COOKIE_KEY = "window.App.Pages.Cities.Search.Components.Concierge.Shown"

const getListViewByType = () => {
  if (PageInstance.isCommercial()){
    return LIST_VIEW_CONCIERGE_TIMES.COMMERCIAL
  }

  return LIST_VIEW_CONCIERGE_TIMES.RESIDENTIAL
}

function getDefaultListViewTimeout(){
  if (MapDefaults.getDefaultCountryCode() === "CN") {
    return getListViewByType().CHINA
  }
  if (MapDefaults.getDefaultCountryCode() === "TW") {
    return getListViewByType().TAIWAN
  }

  return getListViewByType().DEFAULT
}

interface ITimer {
  setTimer: (period?: number) => any,
  delayTimer: () => any,
  clearTimer: () => any,

  getModalShown: () => boolean,
  setModalShown: () => any,
  setModalNotShown: () => any,

  onLoad: () => any,
}
class TimerClass implements ITimer {
  private _timer = null as null | number
  private _time_object = null as null | {
    start_time: number,
    period: number,
  }

  public setTimer(period?: number){
    const period_with_default = period || getDefaultListViewTimeout()

    if (this._timer != null) {
      this.clearTimer()
    }

    // TODO: use cookies from app/search/filter instead
    if (Cookies.get("window.App.Cells.ListingFilter.SAVED")){
      return
    }

    log.debug(`Concierge modal timeout started ${period_with_default}`)

    this._time_object = {start_time: (new Date()).getTime(), period: period_with_default}
    this._timer = window.setTimeout(() => {
      // Avoid delaying timer after modal shown
      this.clearTimer()
      Promise.resolve(
        import("concepts/cities/concierge/buy_rent/modal/index")
      )
      .then(({default: BuyRent_Modal}) => {
        BuyRent_Modal.show()
      })
    }, period_with_default)
  }
  public delayTimer(){
    // delay timer by 30 secs for MOBILE only
    if (!Page.isForMobile()){
      return
    }

    if (this._timer != null && this._time_object != null){
      const elapsed_time = (new Date()).getTime() - this._time_object.start_time
      const new_period = (this._time_object.period - elapsed_time) + 30000

      this.clearTimer()

      this._time_object = {start_time: (new Date()).getTime(), period: new_period}
      this._timer = window.setTimeout(() => {
        // Avoid delaying timer after modal shown
        this.clearTimer()
        Promise.resolve(
          import("concepts/cities/concierge/buy_rent/modal/index")
        )
        .then(({default: BuyRent_Modal}) => {
          BuyRent_Modal.show()
        })
      }, new_period)
    }
  }
  public clearTimer(){
    log.debug("Concierge modal timeout cleared")

    if (this._timer != null) {
      clearTimeout(this._timer)
      this._timer = null
      this._time_object = null
    }
  }

  public onLoad(){
    MapMode.on("list_mode", () => {
      this.setModalNotShown()
      this.setTimer()
    })

    MapMode.on("map_mode", () => {
      this.setModalNotShown()
    })

    MapMode.on("card_mode", () => {
      this.setModalNotShown()
    })

    Promise.resolve(
      import("app/modal/show-modal")
    )
    .then(({default: Modal}) => {
      Modal.on("modal_shown", () => {
        this.delayTimer()
      })
    })
  }

  public getModalShown() {
    return Cookies.get(COOKIE_KEY) != null
  }
  public setModalShown() {
    Cookies.set(COOKIE_KEY, "true")
  }
  public setModalNotShown() {
    Cookies.expire(COOKIE_KEY)
  }
}

const Timer = new TimerClass()


export {
  Timer,
  Timer as default,
}
